import React, { Fragment } from 'react';
import './PhoneScreen.scss';

export default ({ style = {}, children, onClick, divClassName }) => {
	return (
		<div
			style={style}
			onClick={onClick}
			className={divClassName ? divClassName : 'phoneScreenContainer'}
		>
			<Fragment>{children}</Fragment>
		</div>
	);
};
